import React from "react";
import {ConnectedRouter} from "react-router-redux";
import {Provider} from "react-redux";
import {Route, Switch} from "react-router-dom";

import "assets/vendors/style";
import "styles/flexile.less";
import configureStore, {history} from "appRedux/store";
import "firebase/firebase";
import App from "containers/App/index";

import { ApolloProvider } from 'react-apollo';
import client from './apollo';

export const store = configureStore();

const NextApp = () =>
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </ConnectedRouter>
    </Provider>
  </ApolloProvider>;


export default NextApp;



// WEBPACK FOOTER //
// ./src/NextApp.js